const { m } = require('minthril');

function Mission() {
  return {
    view: () => m('aside.mission',
      m('div.mission__image'),
      m('div.mission__content',
        m('p.mission__label', 'The Mid Engine Co. approach'),
        m('p.mission__copy', 'Well-engineered alternatives for the parts that are unavailable, unreliable, or simply not worth the compromise.'),
        m('a.mission__link', { href: '/about' }, 'Read our story →')
      )
    )
  };
}

module.exports = { Mission };
